import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import moment from '../../../lib/moment.js'
import { Container, Row, Col, Button } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  reportAction,
  companyAction,
  lobAction,
  leaveTypeAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  reportSelector,
  companySelector,
  lobSelector,
  leaveTypeSelector,
} from './../../../selectors'
import { searchLeaveHistory } from '../../../function'
import { SearchBarLeaveHistory } from '../../../components/report/search-bar'
import withLayout from '../../../helpers/withLayout'
import LeaveHistoryTable from '../../../components/report/table/leave-history'
import { LeaveHistoryDetail, ModalMessage } from '../../../components/report/modal'
import { ExportLeaveHistory } from '../../../components/report/form/export-leave-history'

class LeaveHistoryReport extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveHistoryData.leaveHistory')) {
      if (get(nextProps, 'getLeaveHistoryData.status') === 200) {
        set(tempState, 'default_leave_history', get(nextProps, 'getLeaveHistoryData.leaveHistory'))
      } else {
        nextProps.showConfirm('errorMessage', get(nextProps, 'getLeaveHistoryData.status'), get(nextProps, 'getLeaveHistoryData.message'))
      }
      nextProps.resetGetLeaveHistory()
    }
    if (get(nextProps, 'getCompanyData')) {
      const list = [{ _id: '', name: 'Company' }]
      list.push(...get(nextProps, 'getCompanyData'))
      set(tempState, 'companys', list)
      nextProps.resetGetCompany()
    }
    if (get(nextProps, 'getLOBData')) {
      const list = [{ _id: '', name: 'LOB' }]
      list.push(...get(nextProps, 'getLOBData'))
      set(tempState, 'default_lobs', list)
      set(tempState, 'lobs', [{ _id: '', name: 'LOB' }])
      nextProps.resetGetLOB()
    }
    if (get(nextProps, 'getLeaveTypeData')) {
      const list = [{ _id: '', name: 'Leave Type' }]
      list.push(...get(nextProps, 'getLeaveTypeData'))
      set(tempState, 'leave_types', list)
      nextProps.resetLeaveType()
    }
    if (get(nextProps, 'exportLeaveHistoryData.url')) {
      if (get(nextProps, 'exportLeaveHistoryData.status') === 200) {
        window.open(get(nextProps, 'exportLeaveHistoryData.url'))
      } else {
        nextProps.showConfirm('errorMessage', get(nextProps, 'exportLeaveHistoryData.status'), get(nextProps, 'exportLeaveHistoryData.message'))
      }
      nextProps.resetExportLeaveHistory()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      showDetail: false,
      default_leave_history: [],
      companys: [],
      default_lobs: [],
      lobs: [],
      leave_types: [],
      selectedCompany: '',
      selectedLOB: '',
      selectedLeaveType: '',
      selectedStatus: '',
      start_date: moment().startOf('year'),
      end_date: moment().endOf('year'),
      search: '',
    }
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    const start_date = moment().startOf('year')
    const end_date = moment().endOf('year')
    this.props.getAuth(access_token)
    this.props.getLeaveHistory(start_date, end_date, access_token)
    this.props.getCompany(access_token)
    this.props.getLOB(access_token)
    this.props.getLeaveType(access_token)
  }

  handleClickRow = (data) => {
    this.setState({
      showDetail: !this.state.showDetail,
      data,
    })
  }

  handleChangeStartDate = (newDate) => {
    this.setState({ start_date: newDate })
    if (newDate !== null && this.state.end_date !== '') {
      const start_date = moment(newDate).utcOffset(0)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DD')
      const end_date = moment(this.state.end_date).utcOffset(0)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DD')
      const access_token = localStorage.getItem('access_token')
      this.props.getLeaveHistory(start_date, end_date, access_token)
    }
  }

  handleChangeEndDate = (newDate) => {
    this.setState({ end_date: newDate })
    if (this.state.start_date !== '' && newDate !== null) {
      const start_date = moment(this.state.start_date).utcOffset(0)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DD')
      const end_date = moment(newDate).utcOffset(0)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DD')
      const access_token = localStorage.getItem('access_token')
      this.props.getLeaveHistory(start_date, end_date, access_token)
    }
  }

  handleInputLeaveHistory = (type, data) => {
    switch (type) {
      case 'company': {
        if (data.target.value === '') {
          this.setState({
            selectedCompany: '',
            selectedLOB: '',
            lobs: [{ _id: '', name: 'LOB' }],
          })
        } else {
          const company = find(this.state.companys, {
            name: data.target.value,
          })
          const newLOB = this.state.default_lobs.filter((element) => {
            return element.company_id === company._id
          })
          this.setState({
            selectedCompany: company.name,
            selectedLOB: '',
            lobs: [{ _id: '', name: 'LOB' }, ...newLOB],
          })
        }
        break
      }
      case 'lob': {
        if (data.target.value !== '') {
          this.setState({ selectedLOB: data.target.value })
        } else {
          this.setState({ selectedLOB: '' })
        }
        break
      }
      case 'leave_type': {
        if (data.target.value !== '') {
          const leave_type = find(this.state.leave_types, {
            name: data.target.value,
          })
          this.setState({ selectedLeaveType: leave_type.name })
        } else {
          this.setState({ selectedLeaveType: '' })
        }
        break
      }
      case 'status': {
        if (data.target.value !== '') {
          this.setState({ selectedStatus: data.target.value })
        } else {
          this.setState({ selectedStatus: '' })
        }
        break
      }
      case 'search': {
        this.setState({ search: data })
        break
      }
      default: break
    }
  }

  filterLeaveHistory = () => {
    const {
      search,
      selectedCompany,
      selectedLOB,
      selectedLeaveType,
      selectedStatus,
      default_leave_history,
    } = this.state
    let leaveHistory = default_leave_history
    if (search !== '') leaveHistory = leaveHistory.filter(searchLeaveHistory, search)
    if (selectedCompany !== '') {
      leaveHistory = leaveHistory.filter((element) => {
        return element.emp_company === selectedCompany
      })
    }
    if (selectedLOB !== '') {
      leaveHistory = leaveHistory.filter((element) => {
        return element.emp_lob === selectedLOB
      })
    }
    if (selectedLeaveType !== '') {
      leaveHistory = leaveHistory.filter((element) => {
        return element.leave_type_name === selectedLeaveType
      })
    }
    if (selectedStatus !== '') {
      leaveHistory = leaveHistory.filter((element) => {
        return element.status === selectedStatus
      })
    }
    return leaveHistory
  }

  selectButton = (confirmStatus, confirmType) => {
    return (
      <Button
        color="warning"
        onClick={ () => this.props.hideConfirm(confirmType) }
      >Try Again</Button>
    )
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsHRUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsPMUser = get(this.props, 'authData.user.is_pm_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectReport.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectReport.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsLOBLeadUser !== undefined &&
      IsHRUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      IsManagementUser !== undefined &&
      IsPMUser !== undefined &&
      IsSystemUser !== undefined &&
      !(IsSystemUser || IsLOBLeadUser || IsHRUser || IsHRConfidentialUser || IsManagementUser || IsPMUser)) window.location = '/home'

    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmType = get(this.props, 'confirmType')
    const confirmMessage = get(this.props, 'confirmMessage')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <SearchBarLeaveHistory
          start_date={ this.state.start_date }
          end_date={ this.state.end_date }
          companys={ this.state.companys }
          lobs={ this.state.lobs }
          leave_types={ this.state.leave_types }
          leave_status={ this.state.leave_status }
          selectedCompany={ this.state.selectedCompany }
          selectedLOB={ this.state.selectedLOB }
          selectedLeaveType={ this.state.selectedLeaveType }
          selectedStatus={ this.state.selectedStatus }
          handleChangeStartDate={ this.handleChangeStartDate }
          handleChangeEndDate={ this.handleChangeEndDate }
          handleInputLeaveHistory={ this.handleInputLeaveHistory }
          export={ () => this.setState({ showExport: !this.state.showExport }) }
        />
        <ModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={ confirmType === 'errorMessage' }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        { this.state.showExport &&
        <ExportLeaveHistory
          open={ this.state.showExport }
          toggle={ () => this.setState({ showExport: !this.state.showExport }) }
          exportLeaveHistory={ this.props.exportLeaveHistory }
        />
        }
        { this.state.showDetail &&
        <LeaveHistoryDetail
          toggle={ () => this.setState({
            showDetail: !this.state.showDetail,
            data: {},
          }) }
          open={ this.state.showDetail }
          history={ this.state.data }
        />
        }
        <Row noGutters>
          <Col>
            { isFetching &&
              <Overlay>
                <OverlayWrapper>
                  <BeatLoader
                    css={ css(`
                      position: absolute;
                      left: 50%;
                      top: 50%;
                    `) }
                    sizeUnit={ "px" }
                    size={ 15 }
                    color={ '#D44B49' }
                    loading={ isFetching }
                  />
                </OverlayWrapper>
              </Overlay>
            }
            <LeaveHistoryTable
              handleClickRow={ this.handleClickRow }
              history={ this.filterLeaveHistory() }
            />
          </Col>
        </Row>
      </Wrapper>
    )
  }
}

LeaveHistoryReport.propTypes = {
  getAuth: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  getLeaveHistory: PropTypes.func.isRequired,
  getLeaveType: PropTypes.func.isRequired,
  exportLeaveHistory: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  getIsFetching: reportSelector.getIsFetching,
  getLeaveHistoryData: reportSelector.getLeaveHistoryData,
  exportLeaveHistoryData: reportSelector.exportLeaveHistoryData,
  getCompanyData: companySelector.getListCompany,
  getLOBData: lobSelector.getListLOB,
  getLeaveTypeData: leaveTypeSelector.getLeaveTypeData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getLeaveHistory: reportAction.getLeaveHistoryReport,
  resetGetLeaveHistory: reportAction.resetGetLeaveHistoryReport,
  exportLeaveHistory: reportAction.exportLeaveHistoryReport,
  resetExportLeaveHistory: reportAction.resetExportLeaveHistoryReport,
  getCompany: companyAction.getCompany,
  resetGetCompany: companyAction.resetListCompany,
  getLOB: lobAction.getLOB,
  resetGetLOB: lobAction.resetListLOB,
  getLeaveType: leaveTypeAction.getLeaveType,
  resetLeaveType: leaveTypeAction.resetGetLeaveType,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(LeaveHistoryReport))

const Wrapper = styled(Container)`
  padding: 0px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/report/leave-history/index.js